import { Column, DataTable } from "components/DataTable/DataTable"
import { HeaderSearch } from "./HeaderSearch"
import { Beacon } from "types/beacon"
import { observer } from "mobx-react"
import { useBeaconlistStore } from "contexts/RootStore.context"
import ShowMoreButton from "components/DataTable/components/ShowMoreButton"
import { BeaconFlyout } from "./BeaconFlyout"
import { useMemo } from "react"
import ArrowCell from "components/DataTable/cells/ArrowCell"
import { style } from "typestyle"
import { Vertical } from "gls"

type RegisteredBeaconListProps = {
  onRefresh: () => void
}
export const RegisteredBeaconList = observer(({ onRefresh }: RegisteredBeaconListProps) => {

  const { loading, beaconList, loadBeacons, getEmptyListMsg,
    selectedBeacon, setSelectedBeacon, nextCount, onSort } = useBeaconlistStore()

  const columns: Column<Beacon>[] = useMemo(() => {
    return [
      { title: 'BEACON ID', field: 'beacon_id' },
      { title: 'BEACON TYPE', field: 'beacon_type' },
      {
        title: 'SOURCE',
        field: 'import_info',
        sortField: "source",
        renderer: (cellValue: any) => cellValue?.source,
        defaultValue: 'manual'
      },
      {
        title: 'ASSET NAME',
        renderer: (cellValue: any) => cellValue?.name,
        field: 'assigned_asset',
        sortField: "asset_name",
        defaultValue: "--"
      },
      {
        title: 'ASSET TYPE',
        renderer: (cellValue: any) => cellValue?.asset_type?.name,
        field: 'assigned_asset',
        sortField: "asset_type",
        defaultValue: "--"
      },
      {
        title: 'ASSET ID',
        renderer: (cellValue: any) => cellValue?.id,
        field: 'assigned_asset',
        sortField: "asset_id",
        defaultValue: "--"
      },
      { title: 'NOTES', noSort: true, field: "notes", defaultValue: "--" },
      {
        title: "",
        noSort: true,
        renderer: () => <ArrowCell />,
        field: '',
        width: '10px',
      },
    ]
  }, [])

  return (
    <Vertical spacing={10} className={boxStyle} sizing="stretch">
      <HeaderSearch />
      <DataTable<Beacon>
        loading={loading}
        columns={columns}
        data={beaconList}
        emptyListMsg={getEmptyListMsg}
        onSort={onSort}
        onRowClick={(row: Beacon) => setSelectedBeacon(row)}
        renderLoadMore={nextCount > 0 && (
          <ShowMoreButton
            fetchFunction={() => loadBeacons()}
            nextIsLoading={loading}
            nextCount={nextCount}
          />
        )}
      />
      {selectedBeacon && <BeaconFlyout
        onRefresh={onRefresh}
        onClose={() => setSelectedBeacon(null)}
        beacon={selectedBeacon}
      />
      }
    </Vertical>
  )
})

const boxStyle = style({
  marginTop: '10px',
  width: '100%',
  overflow: "hidden"
})